import SkeletonAlpha from './Skeleton.alpha';
import SkeletonLegacy from './Skeleton.legacy';

// In alpha builds, NormalModuleReplacementPlugin swaps Skeleton.legacy → Skeleton.alpha,
// so both imports resolve to the same file and no unused package is bundled.
const SkeletonLoader = !process.env.IS_LEGACY ? SkeletonAlpha : SkeletonLegacy;

export default SkeletonLoader;
